export const Loading = () => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="h-10 w-48 animate-pulse rounded-md bg-[#efefef]" />
        <div className="h-4 w-72 animate-pulse rounded-md bg-[#efefef]" />
      </div>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <div className="h-96 animate-pulse rounded-xl bg-[#efefef]" />
        </div>
        <div className="h-48 animate-pulse rounded-xl bg-[#efefef]" />
      </div>
    </div>
  );
};

export default Loading;
